import { makeStyles } from '@material-ui/core/styles';
import { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { color } from './app/theme';
import { TabType } from './app/types';
import Flow from './components/flow/Container';
import Loading from './components/Loading';
import Header from './components/main/Header';
import Initial from './components/main/Initial';
import Setting from './components/setting/Container';

const useStyles = makeStyles(
  () => ({
    root: {
      height: 'calc(100vh - 114px)',
    },
    main: {
      height: 'calc(100vh - 114px)',
      backgroundColor: color.$7,
      margin: '114px 0',
      overflow: 'auto',
    },
    loading: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
    },
  }),
  {
    name: 'MainRoute',
  },
);

function MainRoute() {
  const classes = useStyles();

  return (
    <Switch>
      <Route path="/:orgId">
        <div className={classes.root}>
          <Route path="/:orgId/:procedureId">
            <Header />
            <Initial />
            <main id="App-main" className={classes.main}>
              <Suspense fallback={<Loading />}>
                <Switch>
                  <Route exact path={`/:orgId/:procedureId/${TabType.SETTING}`}>
                    <Setting />
                  </Route>
                  <Route exact path={`/:orgId/:procedureId/${TabType.RULE}`}>
                    <Flow />
                  </Route>
                </Switch>
              </Suspense>
            </main>
          </Route>
        </div>
      </Route>
    </Switch>
  );
}

export default MainRoute;
